import React, { Component } from 'react';
import Head from 'next/head';

import { pages } from '../content.json';

class Services extends Component {

	state = {
		activeService : {}
	}

	componentDidMount(){

		this.setState({
			activeService : {
				index : 0,
				height : this.getHeight( '#services-accordion-item-0-body-inner' )
			}
		});

	}

	scrollTo( ref ){

		window.scrollBy({
      left : 0,
      top :  this.refs[ ref ].getBoundingClientRect().top - 105,
      behavior : 'smooth'
    });

	}

	getHeight( ref ){

		return ( this.refs[ ref ].getBoundingClientRect().height - 15 );

	}

  render(){

		const { services } = pages;
		const { activeService } = this.state;

		return(

			<div>

				<Head>
					<meta name="description" content={ services.meta.description } />
					<title>{ services.meta.title }</title>
				</Head>

				<div className="services">

					<div className="services-header">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<h1>{ services.title }</h1>
								</div>
							</div>
						</div>
					</div>

					<div className="services-body">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									{
										services.content.map( ( object, index ) =>
										<div
											key={ index }
											className={ activeService.index === index ? 'services-accordion-item active' : 'services-accordion-item' }
											ref={ '#services-accordion-item-' + index }
										>
											<a
												href="#"
												className="services-accordion-item-title"
												onClick={ event => {

													event.preventDefault();

													this.setState({
														activeService : {
															index : index,
															height : this.getHeight( '#services-accordion-item-' + index + '-body-inner' )
														}
													});

													setTimeout(
														() => {
															this.scrollTo( '#services-accordion-item-' + index );
														},
														200
													);

												}}
											>
												{ object.title }
												<span
													className="services-accordion-item-icon"
													style={{ backgroundImage : 'url(' + object.icon + ')' }}
												>
												</span>
											</a>
											<div
												className="services-accordion-item-body"
												style={ activeService.index === index ? { height : activeService.height } : { } }
											>
												<div className="services-accordion-item-body-inner" ref={ '#services-accordion-item-' + index + '-body-inner' }>
													{
														object.content.map( ( item, i ) =>
														<p key={ i }>{ item }</p>
														)
													}
												</div>
											</div>
										</div>
										)
										}
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>

		);

	}

}

export default Services;
